import React from 'react';
import { ArenaLiveEditor } from '../live/ArenaLiveEditor';
import type { StudioLiveEditorProps } from '../types/editor.types';
export function ArenaBuilder(props: StudioLiveEditorProps) {
  return <ArenaLiveEditor {...props} />;
}
